<template>
	<div>
		<div class="zalo-chat-widget"
		     data-oaid="2061415747725636566"
		     data-welcome-message=""
		     data-autopopup="0"
		     data-width="400"
		     data-height="400"
		>
		</div>

	</div>

</template>
<script>
export default {
	name: "the-zalo-chat",
	data() {
		return {

		}
	},
	mounted() {


		let recaptchaScript = document.createElement('script')
		recaptchaScript.setAttribute('src', 'https://sp.zalo.me/plugins/sdk.js')
		document.head.appendChild(recaptchaScript)
	},
}
</script>


<style lang="scss">
.zalo-chat-widget {
	right: 23px !important;
	bottom: 40px !important;
	z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Chat/ZaloChat.vue